module.exports = __webpack_public_path__ + "img/200117.9da52204.png";